import parkingLotFilters from '@/app/dashboard/structural/parking-lots/filters';
import { cn } from '@/lib/cn';
import { toReadableAddress } from '@/lib/utils';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import { ParkingLotConfig, type ParkingLot } from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';
export const ParkingLotItem: RelationFieldProps<ParkingLot> = {
  nested: getRelationFieldNames(ParkingLotConfig),
  filters: parkingLotFilters,
  renderItem: (item, isRelationField) => ({
    title: item?.name,
    descriptionItems: (
      <div
        className={cn(
          'flex w-full items-center',
          isRelationField && 'justify-between'
        )}
      >
        <span className='font-medium'>
          {item.address
            ? toReadableAddress(item.address, true, false)
            : 'Ingen adress angiven'}
        </span>
        {!isRelationField && <Dot />}
        <span>{item?.customId ?? 'Inget objekts-id angivet'}</span>
      </div>
    ),
  }),
};
